enum OrderingEnvironmentType {
    webApp,
    cashRegister
}

export default OrderingEnvironmentType;